module.exports = __webpack_public_path__ + "officialStatic/img/productB35.32fc38e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB35.png
// module id = kDFz
// module chunks = 0